import { Injectable } from '@angular/core';
import { ShippingType } from '../enums/ShippingType';
import {ShopData} from "../models/shopData";

@Injectable({
  providedIn: 'root',
})
export class ShoppingSharedService {
  private storage = sessionStorage;

  constructor() {}

  set formData(data: any) {
    this.storage.setItem('formData', JSON.stringify(data));
  }

  get formData(): any {
    return this.storage.getItem('formData') ? JSON.parse(this.storage.getItem('formData')!) : null;
  }

  set products(items: ShopData[]) {
    this.storage.setItem('shopData', JSON.stringify(items));
  }

  get products(): ShopData[] {
    return this.storage.getItem('shopData') ? JSON.parse(this.storage.getItem('shopData')!) : [];
  }

  set totalSumAmd(amount: number) {
    this.storage.setItem('totalSumAmd', amount.toString());
  }

  get totalSumAmd(): number {
    return this.storage.getItem('totalSumAmd') ? parseFloat(this.storage.getItem('totalSumAmd')!) : 0;
  }

  set totalSumUsd(amount: number) {
    this.storage.setItem('totalSumUsd', amount.toString());
  }

  get totalSumUsd(): number {
    return this.storage.getItem('totalSumUsd') ? parseFloat(this.storage.getItem('totalSumUsd')!) : 0;
  }

  set shippingType(type: ShippingType) {
    this.storage.setItem('shippingType', type);
  }

  get shippingType(): ShippingType {
    return (this.storage.getItem('shippingType') as ShippingType) || ShippingType.STANDARD;
  }

  set promoCode(code: string) {
    this.storage.setItem('promoCode', code);
  }

  get promoCode(): string {
    return this.storage.getItem('promoCode') || '';
  }

  clearSessionData() {
    this.storage.removeItem('formData');
    this.storage.removeItem('shopData');
    this.storage.removeItem('totalSumAmd');
    this.storage.removeItem('totalSumUsd');
    this.storage.removeItem('shippingType');
    this.storage.removeItem('promoCode');
  }
}
